module.exports = __webpack_public_path__ + "img/5_87.a799d7bd.png";